// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__12Hbe","actions":"GroupTable_actions__27EaL","deleteModalFooter":"GroupTable_deleteModalFooter__kbwk1"};